export enum ProfilePictureTypeEnums {
  ProfilePicture,
  ProfileThumbnail,
}
